export default {
  'menu.workbench': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': '出張アシスタント',
  'menu.items': '出張事項',
  'menu.trip-analysis': '出張分析',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.settings': '設定',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
